// basic home page in react
import React from "react";
import ContactForm from "../components/ContactForm";
import Code from "../components/Code";

const Home = () => {
    // if GET code is not provided, then we diplay the list of code instanceof the contact Form
    if (window.location.search.indexOf("code") === -1) {
        return (
            <div className="App">
                <header className="App-header">
                    <div className="py-6">
                        <Code />
                    </div>
                </header>
            </div>
        );
    }
    else {
        return (
            <div className="App">
                <header className="App-header">
                    <div className="py-6">
                        <ContactForm/>
                    </div>
                </header>
            </div>
        );
    }
}

export default Home;